export const AUTH_GOOGLE_VERIFY_PATH =
  import.meta.env.VITE_AUTH_GOOGLE_PATH || '/manager/auth/google'
